import locale from "common/managers/locale";
import functions from "common/helper/functions";
import DFDateTimePicker from "app/widgets/DFDateTimePicker/DFDateTimePicker";
import DFDropDownList from "app/widgets/DFDropDownList/DFDropDownList";
export default {

    hideFilterPopups: function() {
        $("form[id^='" + this.element.attr("id") + "_filterMenu_'].k-filter-menu").each(function() {
            var popup = $(this).data("kendoPopup");
            if (popup) {
                popup.close();
            }
        });
    },

    /**
     * Setup the filtering options for each column
     * @private
     */
    _configFilteringColumn: function(options, column) {
        var filterClass = column.filterClass || options.filterClass;
        if (filterClass && column.filterable != false) {
            if (filterClass == "simpleRowFilter") {
                if (column.filterable === true || !column.filterable) {
                    column.filterable = {};
                }
                if (!column.filterable.cell) {
                    column.filterable.cell = {};
                }
                if (column.values) {
                    column.filterable.cell = {
                        operator: "eq",
                        showOperators: false,
                        template: function(element) {
                            new DFDropDownList(element.element, {
                                dataTextField: "text",
                                dataValueField: "value",
                                dataSource: column.values,
                                valuePrimitive: true,
                                optionLabelKey: "select"
                            });
                        }
                    }
                } else if (column.dataSource || column.ds) {
                    column.filterable.cell = {
                        operator: "eq",
                        showOperators: false,
                        template: function(element) {
                            new DFDropDownList(element.element, {
                                dataTextField: column.filterTextField || "text",
                                dataValueField: column.filterValueField || "value",
                                dataSource: column.dataSource || column.ds,
                                valuePrimitive: true,
                                optionLabelKey: "select"
                            });
                        }
                    }
                } else {
                    column.filterable.cell = {
                        suggestionOperator: column.filterOperator || options.filterOperator || "startswith",
                        operator: column.filterOperator || options.filterOperator || "contains",
                        showOperators: false,
                        template: function(element) {
                            element.element.attr("placeholder", locale.get("filter"));
                            element.element.attr("type", "text");
                            var change = functions.debounce(function() {
                                element.element.trigger("change");
                            }, 400);
                            var ignoreTab = function(e) {
                                if (e.keyCode !== 9) {
                                    change();
                                }
                            };
                            element.element.on("keyup", ignoreTab);
                        }
                    };
                }
            } else if (filterClass == "simpleFilter") {
                if (column.filterable === true || !column.filterable) {
                    column.filterable = {};
                }
                var op = column.filterOperator || options.filterOperator;
                if (op == "startswith") {
                    column.filterable.operators = {
                        string: {
                            startswith: locale.get('startswith')
                        }
                    };
                } else if (op == "endswith") {
                    column.filterable.operators = {
                        string: {
                            endswith: locale.get('endswith')
                        }
                    };
                } else if(op === "eq") {
                    column.filterable.operators = {
                        string: {
                            eq: locale.get('equals')
                        }
                    };
                } else {
                    column.filterable.operators = {
                        string: {
                            contains: locale.get('contains')
                        }
                    };
                }
            } else if (filterClass === "simpleDateFilter") {
                if (column.filterable === true || !column.filterable) {
                    column.filterable = {};
                }
                column.filterable.extra = true;
                column.filterable.operators = {
                    date: {
                        gte: locale.get("after"),
                        lte: locale.get("before")
                    },
                    string: {
                        gte: locale.get("after"),
                        lte: locale.get("before")
                    }
                };
                if(!column.filterable.ui) {
                    column.filterable.ui = function(element) {

                        // Per Lauren, do not let them pick a date after the 30 minute time period we are currently in.
                        // 0 and 30 minutes also round up to the next period.
                        // Examples:
                        // 11:00:25 rounds up to 11:30
                        // 11:01:00 rounds up to 11:30
                        // 11:29:99 rounds up to 11:30
                        // 11:30:00 rounds up to 12:00
                        var now = new Date();
                        if (now.getMinutes() < 30) {
                            now.setMinutes(30, 0, 0);
                        } else {
                            now.setMinutes(60, 0, 0);
                        }

                        new DFDateTimePicker(element, {
                            max: now
                        });
                    };
                    this._dateFilters[column.field] = "dfdatetimepicker";
                } else {
                    this._dateFilters[column.field] = column.filterable.ui;
                }
            }
        }
    },

    /**
     * Set up the basic filter configuration.
     * @private
     */
    _configFiltering: function(options) {
        // Set generic filter options, based on filterClass set
        // isTrue and isFalse text currently using in admin/auditing.
        // Make generic if new text is needed for other boolean filters.
        this._dateFilters = {};
        if (options.filterClass) {
            if (options.filterClass == "simpleFilter") {
                options.filterable = {
                    mode: "menu",
                    extra: false,
                    messages: {
                        clear: locale.get("clear"),
                        filter: locale.get("filter"),
                        info: "",
                        isTrue: locale.get("on"),
                        isFalse: locale.get("off")
                    }
                };
            } else if (options.filterClass == "simpleRowFilter") {
                options.filterable = {
                    mode: "row",
                    extra: false
                };
            }
        }

        if (options.filterable && options.filterable.messages) {
            options.filterable.messages.selectValue = locale.get("select");
        }
    },

    _prepareFiltering: function() {
        this.unbindNamespace("filter");
        this.bindWithNamespace("filter", "filter", () => {
            this.wrapper.addClass("keepHeader");
        });
        // Add filter class if configured to do so
        if (this.options.filterClass != undefined) {
            var me = this;
            this.bindWithNamespace("filter", "filterMenuInit", function(e) {
                // always set the ID of the filter form so it can be grabbed during automated testing
                var filterMenuWrapper = e.container.closest("form");
                var idPrefix = this.element.attr("id");
                filterMenuWrapper.attr("id", idPrefix + "_filterMenu_" + e.field);
                filterMenuWrapper.addClass("DFGridFilter");

                // Find all select elements and make sure an ID is set, needed for automated testing.
                e.container.find("select").each(function(idx, select) {
                    if (!$(select).attr("id")) {
                        var selectId = idPrefix + "_filterMenu_" + e.field + "_filterSelect_" + idx;
                        $(select).attr("id", selectId);

                        // Kendo only sets the ID of the drop down list's container on init, we need to
                        // specifically do it here.
                        kendo.widgetInstance($(select)).list.attr("id", selectId + "-list");
                        kendo.widgetInstance($(select)).ul.attr("id", selectId + "_listbox");
                    }
                });

                if (me._dateFilters.hasOwnProperty(e.field)) {
                    filterMenuWrapper.addClass("simpleFilter");
                    const kendoRole = me._dateFilters[e.field];
                    //The filter menu works by binding a model to the controls
                    //there is a control for two operators, two values, and a connective
                    //Kendo may randomly assign(during clear/filter) either set of control to after/before
                    //The goal is to ensure that the first control is always the after control
                    //and the second control is always the before control
                    var drops = e.container.find("[data-role='dropdownlist']");
                    var dates = e.container.find(`[data-role="${kendoRole}"]`);
                    var afterDate = kendo.widgetInstance(dates.eq(0));
                    var after = kendo.widgetInstance(drops.eq(0));
                    var operator = drops.eq(1);
                    var before = kendo.widgetInstance(drops.eq(2));
                    var beforeDate = kendo.widgetInstance(dates.eq(1));
                    var force = function(control, value) {
                        control.value(value);
                        control.trigger("change");
                    };
                    var forceState = function() {
                        var afterValue, beforeValue;
                        if (after.value() == "gte") {
                            afterValue = afterDate.value();
                            beforeValue = beforeDate.value();
                        } else {
                            afterValue = beforeDate.value();
                            beforeValue = afterDate.value();
                        }

                        after.unbind("cascade", forceState);
                        before.unbind("cascade", forceState);
                        afterDate.unbind("change", forceState);
                        beforeDate.unbind("change", forceState);

                        // if before and after are both set, and the before value is before the after value, make them equal.
                        if (beforeValue && afterValue && beforeValue < afterValue) {
                            beforeValue = afterValue;
                        }

                        force(after, "gte");
                        force(afterDate, afterValue);
                        force(before, "lte");
                        force(beforeDate, beforeValue);

                        after.bind("cascade", forceState);
                        before.bind("cascade", forceState);
                        afterDate.bind("change", forceState);
                        beforeDate.bind("change", forceState);
                    };

                    //Replace operator dropdown with simple labels
                    after.wrapper.hide();
                    const afterLabelId = kendo.guid();
                    $("<span>").attr("id", afterLabelId).text(locale.get("after")).insertAfter(after.wrapper);
                    afterDate.setLabelledBy("core", afterLabelId);

                    before.wrapper.hide();
                    const beforeLabelId = kendo.guid();
                    $("<span>").attr("id", beforeLabelId).text(locale.get("before")).insertAfter(before.wrapper);
                    beforeDate.setLabelledBy("core", beforeLabelId);

                    operator.parent().hide();
                    forceState();
                } else {
                    filterMenuWrapper.addClass(me.options.filterClass);
                }

                e.container.attr("aria-label", locale.get("filter.item", this._getColumnLabel(e.field)));
            });

            me.element.find(".k-filter").on("click", function(e) {
                // When the grid is disabled, prevent filtering
                if (!me.enabled) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                // Cancel changes upon opening the filtering menu, while in edit mode
                if (me.element.find("tbody").find(".k-grid-edit-row").length) {
                    me.cancelRow();
                    me.trigger("dfgrid/editDone");
                }
            });
        }
    },

    _getColumnLabel: function(field) {
        for (var i = 0; i < this.columns.length; i++) {
            if (this.columns[i].field === field && this.columns[i].title) {
                return this.columns[i].title
            }
        }
        return field;
    },

    focusOnFilter: function() {
        if (this.options.filterClass == "simpleRowFilter") {
            var filterField = this.thead.find(".k-filter-row input")[0];
            if (filterField != null) {
                filterField.focus();
            }
        }
    }
};
